<template>
    <div class="headContent between">
        <!-- <el-image :src="require('@/assets/icon/suc.png')" fit="cover" class="logo" @click="logoTap"></el-image> -->
        <el-image :src="logoImg" fit="cover" class="logoName" @click="logoTap"></el-image>
        <div class="headTopNavList align">
            <div :class="['headTopNav',active == index && !isMy ? 'headTopNavOn' : '']" v-for="(item,index) in 1" :key="index">首页</div>
        </div>
        <div class="headTopLogin" @click="getLogin">{{ userId == '0' ? '进入开放平台' : '退出登录' }}</div>
        <el-image :src="require('@/assets/image/loginBg.jpg')" fit="cover" style="width:0;height:0;position: fixed;left: -100px;top: -100px;"></el-image>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                userId: 0,
                logoImg: '',
                headData: {},
                active: 0,
                isMy: false
            }
        },
        watch:{
            $route(to,from){
                if(from.path == '/login/login'){
                    this.userId = localStorage.getItem("userId") || 0
                }
                this.isMy = to.path == '/my/my' ? true : false
                console.log(to.path)
                console.log(this.isMy)
            }
        },
        created() {
            
        },
        mounted(){
            console.log
            this.userId = localStorage.getItem("userId") || 0
            this.getAppLogo()
            // this.getAppHead()
        },
        methods: {
            // 网站logo
            getAppLogo(){
                this.request.get("api/index/pclogo",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.logoImg = res.data
                })
            },
            // 网站头数据
            getAppHead(){
                this.request.get("index/index/top",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.headData = res.data
                })
            },
            // logo点击
            logoTap(){
                this.$router.push({ path:'/' })
            },
            // 登录/退出登录
            getLogin(){
                if(this.userId == '0'){
                    this.$router.push({ path:'/login/login', query:{router: 'union'} })
                }else{
                    localStorage.removeItem('userId')
                    this.$router.go(0)
                }
            },
            // tab切换
            headTabTap(i,e){
                this.active = i
                this.$router.push({ path:e })
            },
        }
    }
</script>
<style lang="less" scoped>
    .headContent{
        width: calc(100vw - 96px);
        height: 96px;
        padding: 0 48px;
        background: #fff;
        .headTopLogo{
            width: 54px;
            height: 54px;
            cursor: pointer;
        }
        .logoName{
            width: auto;
            height: 54px;
            margin-left: 8px;
            cursor: pointer;
        }
        .headTopNavList{
            flex: 1;
            margin: 0 50px;
            padding: 0 27px;
            height: 44px;
            border-left: 1px solid rgba(0,0,0,0.08);
            border-right: 1px solid rgba(0,0,0,0.08);
            .headTopNav{
                padding: 0 27px;
                font: 16px/54px "Microsoft YaHei";
                color: #47474f;
                cursor: pointer;
                &:hover{
                    color: #ff601c;
                }
            }
            .headTopNavOn{
                color: #ff601c;
            }
        }
        .headTopLogin{
            width: 132px;
            height: 38px;
            background: #FF601C;
            border-radius: 4px;
            font: 14px/38px "Microsoft YaHei";
            color: #fff;
            text-align: center;
            cursor: pointer;
        }
    }
</style>